/**
 * How urgent an unreported deadline is (DEV-103), pure and React-free.
 *
 * The highlighting grows as the deadline nears: 72 h and 48 h in yellow, 24 h
 * and overdue in red — the function colours, never orange.
 */
import type { CaseClock } from '../../lib/types';

/** 0 more than 72 h left or nothing running, 1 ≤ 72 h, 2 ≤ 48 h, 3 ≤ 24 h, 4 overdue. */
export type ClockUrgency = 0 | 1 | 2 | 3 | 4;

export function clockUrgency(clock: Pick<CaseClock, 'state' | 'remaining_hours' | 'submitted_at'>): ClockUrgency {
  if (clock.submitted_at || clock.remaining_hours === null) return 0;
  if (clock.state === 'overdue' || clock.remaining_hours < 0) return 4;
  if (clock.remaining_hours <= 24) return 3;
  if (clock.remaining_hours <= 48) return 2;
  return clock.remaining_hours <= 72 ? 1 : 0;
}
